import PreRollIntake from './preroll-intake';
function App() { return <PreRollIntake />; }
export default App;